import { PaginatedResult, PaginationRequest } from "@ews/react-data";
import Icon from "@ews/react-icons";
import { useL10n } from "@ews/react-localization-context";
import { IonButton, IonCol, IonList, IonRow } from "@ionic/react";
import { pencilOutline } from "ionicons/icons";
import { useCallback, useEffect, useState } from "react";
import FilterList, { isFilterActive } from "../../../FilterList/FilterList";
import { FilterState } from "../../../FilterList/types";
import List from "../../../List/List";
import { defaultPageRange } from "../../../List/Pagination/pagerange";
import { MenuLink } from "../../../Navigation/Sidebar/Sidebar";
import { usePersistentState } from "../../../Persistence";
import { useFetchSystemPSUs } from "../../../ReactData/system";
import { useIsMobile } from "../../../Responsive";
import { Filter } from "../types/reportTypes";
import PSUModal from "./PSUModal/PSUModal";
import { PowerUnitsDocumentationProps, PSU } from "./types";

type PersistenceFilter = Filter<{}> & FilterState;


const standardFilter: Filter<{}, keyof PSU> = {
    sortCriteria: "type",
    sortOrder: "DESC",
    pageSize: defaultPageRange
};


const PowerUnitsDocumentation: React.FC<PowerUnitsDocumentationProps> = ({
    systemId,
    onIsOpen,
    filter
}) =>
{
    const filterData = useFetchSystemPSUs();
    const mobileView = useIsMobile();

    const [result, setResult] = useState<PaginatedResult<PSU>>({
        currentPage: 0,
        pageSize: standardFilter.pageSize || defaultPageRange,
        totalCountOfEntries: 0,
        totalCountOfPages: 0,
        results: [],
    });
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [currentPSU, setCurrentPSU] = useState<PSU | null>(null);

    const { translate: t } = useL10n();

    const [currentState, setState] = usePersistentState<PersistenceFilter>('system:psus', { ...standardFilter } as PersistenceFilter);

    const isFilterChanged = isFilterActive(currentState, standardFilter, []);

    const getFilteredData = useCallback(async (id: string, filter: PaginationRequest) =>
    {
        const response = await filterData(id, filter);

        if (!response) return;

        let idCounter = 0;
        response.results.map(item =>
        {
            item.id = idCounter;
            idCounter++;
            return item;
        });
        setResult(response);
    }, [filterData]);

    useEffect(() =>
    {
        if (filter?.buttonPressed) {
            const isOpen = filter.isOpen;
            setState({ ...currentState, isFilterOpen: isOpen });
        }

    }, [filter]);

    useEffect(() =>
    {
        if ("isFilterOpen" in currentState) {
            onIsOpen && onIsOpen(currentState.isFilterOpen || false, false, isFilterChanged);
        }

    }, [currentState]);

    useEffect(() =>
    {
        if (systemId) { getFilteredData(systemId, currentState); }


    }, [currentState, systemId]);

    return <>
        <FilterList
            onReset={() => setState(standardFilter)}
            isOpen={filter?.isOpen}
            onIsOpen={(state) =>
            {
                onIsOpen && onIsOpen(state, true, isFilterChanged);
            }}
            onDetailOpen={(isDetailOpen) =>
            {
                if (isDetailOpen) {
                    currentState.isDetailOpen = isDetailOpen;
                } else {
                    delete currentState.isDetailOpen;
                }
                setState({ ...currentState });
            }}
            noPrint
        >
            <IonCol >
                <IonRow class="ion-justify-content-end">
                    <IonButton
                        color={'success'}
                        onClick={() => setIsOpen(true)}
                    >
                        {t('[REACT_ADD_PSU]')}
                    </IonButton>
                </IonRow>
            </IonCol>
        </FilterList >



        <List
            rows={result.results}
            onSort={(sortCriteria, sortOrder) => setState({ ...currentState, sortCriteria, sortOrder })}
            currentPage={result.currentPage}
            numberOfPages={result.totalCountOfPages}
            pageSize={result.pageSize}
            onPageChange={(page) => setState({ ...currentState, page })}
            onPageSize={(pageSize) => setState({ ...currentState, pageSize })}
            sort={currentState.sortCriteria ? {
                key: currentState.sortCriteria,
                direction: currentState.sortOrder || "ASC"
            } : undefined}
            onMenu={(id: number, onMenuToggle: () => void) =>
                <>
                    <div />

                    <IonList>

                        <MenuLink
                            title="COM_LOCALISE_ACCESS_EDIT"
                            icon={pencilOutline}
                            onClick={() =>
                            {
                                const foundPsu = result.results.find(data => { return data.id === id; });
                                if (foundPsu) {
                                    setCurrentPSU(foundPsu);
                                    setIsOpen(true);
                                };
                                onMenuToggle();
                                return null;
                            }} />
                        <MenuLink title="COM_LOCALISE_ACCESS_DELETE" icon={<Icon icon="delete" />} onClick={() =>
                        {
                            const foundPsu = result.results.find(data => data.id === id);

                            if (foundPsu) {
                                /*               _delete(foundedPhoneData); */
                            };
                            onMenuToggle();
                            return null;
                        }} />
                    </IonList>
                </>
            }
            //maxHeight={mobileView ? undefined : filterDetailsOpen ? '45vh' : "61vh"}
            headers={[
                {
                    title: '[REACT_POWER_UNIT_TYPE]', key: 'type', both: true
                },
                {
                    title: '[REACT_CURRENT_CONSUMPTION_AT_MAINS_FAULT_[MA]]', key: 'maxCurrent', both: true
                },
                {
                    title: 'COM_FACPMANAGEMENT_FACP_FIELD_SOFTWARE_VERSION_LABEL', key: 'fwVersion', both: true
                },
                {
                    title: 'TD_SERIENNUMMER', key: 'serialNo', both: true
                },
                {
                    title: 'TD_TEXT', key: 'text', both: true
                },
                {
                    title: '[REACT_PROPERTIES]', key: 'properties', both: true
                },
                {
                    title: 'COM_FACPMANAGEMENT_POWERSUPPLIES_RATED_CURRENT', key: 'ratedCurrent', both: true
                },
                /*  {
                     title: 'fireAlarmCurrent', key: 'fireAlarmCurrent', both: true
                 }, */
                /*  {
                     title: 'bridgingTime', key: 'bridgingTime', both: true
                 } */
            ]}

        />
        <PSUModal
            title={currentPSU ? "[REACT_EDIT_PSU]" : "[REACT_NEW_PSU]"}
            isOpen={isOpen}
            onUpdate={() =>
            {
                if (systemId) {
                    getFilteredData(systemId, currentState);
                }
            }}
            onDismiss={() =>
            {
                setCurrentPSU(null);
                setIsOpen(false);
            }}
            type={currentPSU ? "edit" : "new"}
            data={currentPSU || undefined}
            systemId={systemId}
        />
    </>;
};

export default PowerUnitsDocumentation;
